import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const DesktopSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.78296 14.4813H18.2171C19.3255 14.4813 20 13.8068 20 12.6983V2.35383C20 1.24871 19.3255 0.570862 18.2171 0.570862H1.78296C0.674476 0.570862 0 1.24871 0 2.35383V12.6983C0 13.8068 0.674476 14.4813 1.78296 14.4813ZM1.59021 10.8439C1.32851 10.8439 1.20344 10.7371 1.20344 10.4646V2.37549C1.20344 2.00582 1.43493 1.7743 1.80797 1.7743H18.192C18.5651 1.7743 18.7966 2.00582 18.7966 2.37549V10.4646C18.7966 10.7371 18.679 10.8439 18.4098 10.8439H1.59021ZM7.36364 16.5612H12.6439V14.373H7.36364V16.5612ZM7.28904 17.4289H12.7185C13.0501 17.4289 13.3235 17.1663 13.3235 16.8272C13.3235 16.4914 13.0501 16.2213 12.7185 16.2213H7.28904C6.9499 16.2213 6.67649 16.4914 6.67649 16.8272C6.67649 17.1663 6.9499 17.4289 7.28904 17.4289Z"
        fill={color}
      />
    </svg>
  );
};

export { DesktopSvg };
